import { GetLeaguesApi } from "../../adapters/get-leagues";

export const useGetLeagues = () => {
  const { data } = GetLeaguesApi();

  return {
    data,
  };
};
